import LogsService from './LogsService.js';

export default LogsService;